<script lang="ts">
  import { Button, Icon } from '$shared/components';
  import { BannerType } from '$shared/constants/BannerType';
  import type Banner from '$provider/lib/apis/models/Banner';
  import { type Snippet } from 'svelte';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';

  const DefaultActionLabel = 'Details';

  interface Props {
    options: Banner;
    subDesc?: Snippet | undefined;
    onclose?: () => void;
    onaction?: (e: MouseEvent) => void;
    oncredagentclick?: (e: MouseEvent) => void;
  }

  let { options, subDesc = undefined, onclose, onaction, oncredagentclick }: Props = $props();

  const onClickClose = (): void => {
    onclose?.();
  };
</script>

<div class={`comp-banner ${options?.type}`}>
  <div class="banner">
    <div class="banner-info">
      {#if options?.icon}
        <div class="banner-info-i icon">
          <Icon value={options?.icon} />
        </div>
      {/if}
      <div data-cy="bannerTitle" class="banner-info-i status">
        <b class:hasStatus={options?.status}>{options?.title}</b>{options?.status || ''}
      </div>
    </div>
    {#if !options?.hasCustomDesc && options?.desc}
      <div data-cy="bannerDesc" class="sub-content">{options?.desc}</div>
    {/if}
    {@render subDesc?.()}
  </div>
  <div class="banner-action" class:hasClosable={options?.closable}>
    {#if options?.closable}
      <div class="close-icon">
        <button
          data-cy="closeAlert"
          disabled={options?.disabledCloseAction}
          type="button"
          class="close-button"
          onclick={onClickClose}
        >
          <Icon value="icon-x grey" />
        </button>
      </div>
    {/if}
    {#if options?.hasCredAgentLink}
      <div class="credagent-link-wrapper">
        <Button name="credagent-link" style={ButtonStyle.Link} onclick={oncredagentclick}>
          <span class="credagent-text">CredAgent</span>
          <Icon value="icon-external-link" />
        </Button>
      </div>
    {/if}
    {#if options?.hasAction}
      <Button style={ButtonStyle.Link} onclick={onaction}>{options?.actionLabel || DefaultActionLabel}</Button
      >
    {/if}
  </div>
</div>

<style src="./Banner.css">
</style>
